import { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";

const links = [
  { to: "/", label: "Home" },
  { to: "/diensten", label: "Diensten" },
  { to: "/methode", label: "Methode" },
  { to: "/digitale-regie", label: "Digitale regie" },
  { to: "/voor-wie", label: "Voor wie" },
  { to: "/over-soveu", label: "Over SovEU" },
  { to: "/contact", label: "Contact" },
];

export default function Navigation() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 bg-white border-b transition-shadow ${
        scrolled ? "border-[#E5E9EF] shadow-[0_1px_0_rgba(30,58,95,0.04)]" : "border-transparent"
      }`}
    >
      <div className="container-soveu flex items-center justify-between h-[96px]">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center"
          style={{ color: "#1E3A5F" }}
          onClick={() => setOpen(false)}
          aria-label="SovEU — home"
        >
          <Logo size={48} wordmarkSize="text-[22px]" />
        </Link>

        {/* Desktop menu */}
        <nav className="hidden md:flex items-center gap-7" aria-label="Hoofdnavigatie">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-cta"
            className="ml-2 inline-flex items-center gap-1.5 rounded-md px-4 py-2 text-[14px] font-semibold text-white transition-colors"
            style={{ backgroundColor: "#1E3A5F" }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#2D6F8F")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#1E3A5F")}
          >
            Plan gesprek
          </Link>
        </nav>

        {/* Mobile toggle */}
        <button
          type="button"
          aria-label="Menu openen"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-md hover:bg-[#F5F7FA]"
          style={{ color: "#1E3A5F" }}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t border-[#E5E9EF] bg-white" data-testid="nav-mobile-menu">
          <nav className="container-soveu py-4 flex flex-col gap-1" aria-label="Mobiele navigatie">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `py-3 px-2 text-[15px] font-medium rounded-md ${
                    isActive ? "text-[#1E3A5F] bg-[#F5F7FA]" : "text-[#1A1A1A] hover:bg-[#F5F7FA]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
